var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC4WwwIconsWhiteNoCircleUnRmt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line_Work",
    "data-name": "Line Work"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.52368,
    y: 51.76357,
    width: 16.70758,
    height: 14.60603,
    rx: 0.33482
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 49.87747,
    cy: 59.06659,
    r: 5.06466
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 49.87747,
    cy: 59.06659,
    r: 1.89504
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.09931,
    y: 11.22413,
    width: 21.55632,
    height: 77.55173,
    rx: 0.68709
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.65563,43.92V11.91122a.68709.68709,0,0,0-.68709-.68709H39.7864a.68709.68709,0,0,0-.68709.68709V43.92a.7296.7296,0,0,0,.7296.7296H59.926A.7296.7296,0,0,0,60.65563,43.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.52368,
    y: 46.85244,
    width: 16.70758,
    height: 2.70831,
    rx: 0.32729
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4WwwIconsWhiteNoCircleUnRmt);
export default __webpack_public_path__ + "static/media/C4_WWW_Icons_White_No_Circle_Un_Rmt.254023654a8d2e26cfa61da74006e630.svg";
export { ForwardRef as ReactComponent };